import { render, staticRenderFns } from "./AlertCustomizeModal.vue?vue&type=template&id=6f0d8c9e&scoped=true&"
import script from "./AlertCustomizeModal.vue?vue&type=script&lang=js&"
export * from "./AlertCustomizeModal.vue?vue&type=script&lang=js&"
import style0 from "./AlertCustomizeModal.vue?vue&type=style&index=0&id=6f0d8c9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0d8c9e",
  null
  
)

export default component.exports